<p-toast position="top-right"></p-toast>
<div class="p-g req-management">
  <div class="p-g-12">
    <div class="card card-w-title" [ngClass]="{ 'loading': loading }">

      <div *ngIf="loading" class="loader-overlay"><p-progressSpinner [style]="{width: '32px', height: '36px'}"
          styleClass="custom-spinner" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
      </div>

      <h1 class="req-Title" style="padding-top: 20px; padding-left: 10px;">{{setLabel("contactUsLabel")}}</h1>
      <p-table #dt dataKey="id" styleClass="p-table-customers req-management-table"
      [rowHover]="true" [rows]="100" [showCurrentPageReport]="true" [loading]="loading" [paginator]="true"
      currentPageReportTemplate="There are records" [filterDelay]="0" [value]="contactUsdata"
      [globalFilterFields]="['name','country.name','representative.name','status']" class="p-table-tecfolk-fix">




        <ng-template pTemplate="header">
          <tr>
            <th style="text-align: left; width: 80px;">{{setLabel("srNoLabel")}}</th>
            <th style="text-align: left; width: 200px;">{{setLabel("createdDateLabel")}}</th>
            <th style="text-align: left;">{{setLabel("nameLabel")}}</th>
            <th style="text-align: left;">{{setLabel("phoneLabel")}}</th>
            <th style="text-align: left;">{{setLabel("emailLabel")}}</th>
            <th style="text-align: left;">{{setLabel("subjectLabel")}}</th>
            <th style="text-align: left; width: 110px;">{{setLabel("messageLabel")}}</th>
            <th style="text-align: left;">{{setLabel("sourceLabel")}}</th>
          </tr>

        </ng-template>
        <ng-template pTemplate="body" let-contactUsdata>
          <tr class="p-selectable-row ">

            <td>
              <div class="req-Lable">{{setLabel("srNoLabel")}}</div>
              <span class="p-column-title">{{ contactUsdata.counter }}</span>
            </td>
            <td class="td" style="text-align: left;">
              <div class="req-Lable">{{setLabel("createdDateLabel")}}</div>
              <span class="p-column-title">{{ contactUsdata.createdDate | date: 'M/d/yy h:mm a' }}</span>
            </td>
            <td class="td" style="text-align: left;">
              <div class="req-Lable">{{setLabel("nameLabel")}}</div>
              <span class="p-column-title">{{contactUsdata.name}}</span>
            </td>
            <td class="td" style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("phoneLabel")}}</div>
              <span class="p-column-title" title="{{ contactUsdata?.phone }}">{{contactUsdata.phone}}</span>
            </td>
            <td class="td" style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("emailLabel")}}</div>
              <span class="p-column-title"  title="{{ contactUsdata?.email }}">{{contactUsdata?.email}}</span>
            </td>
            <td class="td" style="text-align: left;" class="column-container">
              <div class="req-Lable">{{setLabel("subjectLabel")}}</div>
              <span class="p-column-title" title="{{ contactUsdata?.contact }}">{{contactUsdata?.subject}}</span>
            </td>
            <td class="td" style="text-align: left;" class=" column-container">
              <div class="req-Lable">{{setLabel("messageLabel")}}</div>
              <span class="message-icon" (click)="openMessageDialog(contactUsdata.message)">
                <i class="fa fa-comment-o" style="cursor: pointer;" title="View Message"></i>
              </span>
            </td>
            <td class="td" style="text-align: left;" class=" column-container">
              <div class="req-Lable">{{setLabel("sourceLabel")}}</div>
              <span>{{contactUsdata.source}}</span>
            </td>
          </tr>
        </ng-template>

  <ng-template pTemplate="footer">
    <tr>
      <td></td>
      <td></td>
      <td colspan="2">{{setLabel("overallTotal:Label")}}</td>
      <td>{{totalCounter}}</td>
    </tr>
  </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7" style="text-align:left">{{setLabel("noContactUsFoundLabel")}}</td>
          </tr>
        </ng-template>
      </p-table>
      <div class="content" style="width: 50%; margin-left: auto;">
        <p-table [value]="tableData">
          <ng-template pTemplate="header">
          </ng-template>
      </p-table>
    </div>
    </div>
  </div>
</div>
<p-dialog header="Message" [(visible)]="displayMessageDialog" [modal]="true" [dismissableMask]="true"
  [baseZIndex]="10000" [style]="{ width: '500px' }" styleClass="my-unique-dialog">
  {{ selectedMessage }}
</p-dialog>